import React, { useRef } from "react";
import { useForm } from "react-hook-form";
import emailjs from "@emailjs/browser";
import { useState } from "react";
// import ReCAPTCHA from "react-google-recaptcha";

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  // const reCaptchaRef = useRef();
  const formRef = useRef();
  const [emailSentMessage, setEmailSentMessage] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const onSubmit = async (e) => {
    emailjs
      .sendForm(
        "service_6ecvdfp",
        "template_n3kp01p",
        formRef.current,
        "j4hlJhaYxC45mfgqB"
      )
      .then(
        (result) => {
          setEmailSentMessage(
            `Thank you for contacting us. We'll be in touch soon`
          );
        },
        (error) => {
          setErrorMessage(
            `There was a problem with sending email. Please try again.`
          );
        }
      );
  };

  return (
    <div className="w-full">
      {emailSentMessage ? (
        <>
          <div
            class="flex justify-center p-4 mb-4 text-xl text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
            role="alert"
          >
            <span class="font-medium">{emailSentMessage}</span>
          </div>
        </>
      ) : (
        <>
          <h1 className="text-center text-4xl font-semibold mt-10">
            How can we help?
          </h1>
          {!!errorMessage && (
            <div
              class="flex justify-center p-4 mb-4 text-xl text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
              role="alert"
            >
              <span class="font-medium">{errorMessage}</span>
            </div>
          )}
          <form
            ref={formRef}
            className="w-full py-10 mt-10 px-12 border"
            onSubmit={handleSubmit(onSubmit)}
          >
            <label className="text-gray-600 font-medium">
              What’s your name?*
            </label>
            <input
              className={`border-solid border-gray-300 border py-2 px-4 w-full rounded text-gray-700 ${
                errors?.name?.message ? "border-2 border-rose-600" : ""
              }`}
              name="name"
              {...register("name", {
                required: "Please enter your name and surname",
                maxLength: 80,
              })}
            />
            {errors?.name && (
              <div className="mb-3 text-normal text-red-500">
                {errors.name.message}
              </div>
            )}
            <label className="text-gray-600 font-medium block mt-4">
              How can we reach you?*
            </label>
            <input
              className={`border-solid border-gray-300 border py-2 px-4 w-full rounded text-gray-700 ${
                errors?.contact?.message ? "border-2 border-rose-600" : ""
              }`}
              name="contact"
              type="text"
              {...register("contact", {
                required:
                  "Please enter a contact information example: email, phone number etc.",
                maxLength: 100,
              })}
            />
            {errors?.contact && (
              <div className="mb-3 text-normal text-red-500 ">
                {errors.contact.message}
              </div>
            )}
            <label className="text-gray-600 font-medium block mt-4">
              Tell us about your needs*
            </label>
            <textarea
              className={`border-solid border-gray-300 border py-5 px-4 w-full rounded text-gray-700 ${
                errors?.description?.message ? "border-2 border-rose-600" : ""
              }`}
              name="description"
              rows={5}
              cols={5}
              {...register("description", {
                required: "Please enter you message",
              })}
            />
            {errors?.description && (
              <div className="mb-3 text-normal text-red-500 ">
                {errors.description.message}
              </div>
            )}
            <div className="flex justify-center	">
              {/* <ReCAPTCHA
            sitekey={process.env.REACT_APP_SITE_KEY}
            ref={reCaptchaRef}
            onChange={onChange}
          /> */}
            </div>
            <button
              className="mt-4 w-full bg-[#00df9a] hover:opacity-75 text-black border py-3 px-6 font-semibold text-md rounded"
              type="submit"
            >
              Submit
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ContactForm;
